<div class="ui-card" [ngStyle]="getCardStyles()" [ngClass]="item.styleClass">
  <ng-content></ng-content>
</div>
